import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullBusiness on Business {
    uuid
    businessName
    globalAdminRoleId
    globalAdminIds
    isEnabled
    loginPageSsoButtonText
    rootTeamId
    showPasswordLogin
    showSsoLogin
    subdomain
    featureFlags
    metadata {
      createdAt
      createdBy
    }
    contractStartDate
    selfRegistrations
    businessType
  }
`

export const toString = fragment.loc.source.body

export default fragment
